class GuessEvent {
    user: string;
    userAgent: string;
    tripleId: number;
    attemptIdx: number;
    guess0: string;
    guess1: string;
    guess2: string;
    correct: boolean;
    numPoints: number;
    duration: number;
    submitTime: Date;
    numInstructionViews: number;
    numCapstonesRevealed: number;
    usedOrderClues: boolean;
    numCheckAllGuesses: number;
    usedRevealAllAnswers: boolean;
    numChecksGuess0: number;
    numChecksGuess1: number;
    numChecksGuess2: number;
    usedRevealAnswer0: boolean;
    usedRevealAnswer1: boolean;
    usedRevealAnswer2: boolean;
    hardMode: boolean;
    numRevealedLetters0: number;
    numRevealedLetters1: number;
    numRevealedLetters2: number;
    build: string;
    clientVersion: string;
    numCorrectCheckGuess0: number;
    numCorrectCheckGuess1: number;
    numCorrectCheckGuess2: number;
    numIncorrectCheckGuess0: number;
    numIncorrectCheckGuess1: number;
    numIncorrectCheckGuess2: number;
    turnType: number;
    difficultyLevel: number;
    sessionId: string;
    newUser: boolean;
    gameState: string;
    hostname: string;
    solveOrder: string;

    static from(obj) {
        return Object.assign(new GuessEvent(), obj);
    }
}

export { GuessEvent };
